import { Components } from '@mui/material'

import Fonts from '#/styles/Fonts'

export function OverridedSvgIcon(): Components {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeLarge: {
          fontSize: '3.1875em',
        },
        fontSizeMedium: {
          fontSize: 20,
        },
        root: {
          fontSize: Fonts.fontSize.XXL,
        },
      },
    },
  }
}
